import React from "react";
import { UserPersonaCard } from "./user-persona-card";
import { usePathname, useRouter } from "expo-router";

function UserPersonaOptions() {
  const router = useRouter();
  const pathname = usePathname();
  const isSignUp = pathname.includes("sign-up-options");

  const onNavigate = (persona: "parent" | "tutor" | "student") => {
    if (persona === "student" && isSignUp) {
      router.push("/(auth)/student/check");
      return;
    }
    if (isSignUp) {
      router.push(`/(auth)/sign-up?persona=${persona}`);
    } else {
      router.push(`/(auth)/sign-in?persona=${persona}`);
    }
  };

  return (
    <>
      <UserPersonaCard intent="primary" onPress={() => onNavigate("parent")}>
        <UserPersonaCard.Title intent="primary">
          I&apos;m a Parent
        </UserPersonaCard.Title>
        <UserPersonaCard.SubTitle intent="primary">
          Looking for tutors
        </UserPersonaCard.SubTitle>
      </UserPersonaCard>
      <UserPersonaCard intent="secondary" onPress={() => onNavigate("tutor")}>
        <UserPersonaCard.Title intent="secondary">
          I&apos;m a Tutor
        </UserPersonaCard.Title>
        <UserPersonaCard.SubTitle intent="secondary">
          Offering lessons
        </UserPersonaCard.SubTitle>
      </UserPersonaCard>
      <UserPersonaCard intent="tertiary" onPress={() => onNavigate("student")}>
        <UserPersonaCard.Title intent="tertiary">
          I&apos;m a Student
        </UserPersonaCard.Title>
        <UserPersonaCard.SubTitle intent="tertiary">
          Ready to learn
        </UserPersonaCard.SubTitle>
      </UserPersonaCard>
    </>
  );
}

export default UserPersonaOptions;
